import React, { useState, useEffect } from 'react';
import Header from '../component/Header';
const API = process.env.REACT_APP_API_URL;

const API_KEY = 'my_secret_key_123';

const SendMessage = () => {
    const [devices, setDevices] = useState([]);
    const [selectedDevice, setSelectedDevice] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [message, setMessage] = useState('');
    const [imageUrl, setImageUrl] = useState('');
    const [imageUrls, setImageUrls] = useState([]);
    const [attachmentFile, setAttachmentFile] = useState(null);
    const [uploadedAttachment, setUploadedAttachment] = useState(null);
    const [isSending, setIsSending] = useState(false);
    const [sendType, setSendType] = useState('single');
    const [bulkNumbers, setBulkNumbers] = useState('');
    const [sendResult, setSendResult] = useState(null);
    const [streamResults, setStreamResults] = useState([]);
    const [activeTab, setActiveTab] = useState('compose');
    const [phoneError, setPhoneError] = useState('');
    const [isPaused, setIsPaused] = useState(false); // NEW: Track pause state

    // Fetch available devices
    const fetchDevices = async () => {
        try {
            const res = await fetch(`${API}/api/devices/connected`);
            const data = await res.json();
            if (Array.isArray(data)) {
                setDevices(data);
                if (data.length > 0 && !selectedDevice) {
                    setSelectedDevice(data[0].id);
                }
            }
        } catch (e) {
            console.error("Failed to fetch devices:", e);
        }
    };

    useEffect(() => {
        fetchDevices();
    }, []);

    // ========== PHONE NUMBER VALIDATION FUNCTIONS ==========
    const validatePhoneNumber = (number) => {
        const cleaned = number.replace(/\D/g, '');
        
        if (!cleaned) {
            return { valid: false, message: 'Phone number is required' };
        }

        if (cleaned.length < 10) {
            return { valid: false, message: 'Phone number must be at least 10 digits' };
        }

        const validPrefixes = ['91', '971', '1', '44', '61', '86', '81', '49', '33', '39', '34', '55', '7', '966', '92', '880', '94', '977', '60', '65', '63', '62', '66', '84', '82', '64', '27', '234', '254', '20', '212', '216', '90', '98', '972', '964', '965', '968', '974', '973'];
        
        if (cleaned.length === 10) {
            return { valid: true, message: 'Valid Indian number (will add +91)' };
        }
        
        const hasValidPrefix = validPrefixes.some(prefix => cleaned.startsWith(prefix));
        if (!hasValidPrefix && cleaned.length > 10) {
            return { valid: false, message: 'Invalid country code. Use 91 for India, 971 for UAE, etc.' };
        }

        if (cleaned.length === 12 && cleaned.startsWith('91')) {
            const remaining = cleaned.substring(2);
            if (remaining.length === 10 && /^[6-9]\d{9}$/.test(remaining)) {
                return { valid: true, message: 'Valid Indian mobile number' };
            }
        }

        if (cleaned.length === 11 && cleaned.startsWith('1')) {
            const remaining = cleaned.substring(1);
            if (remaining.length === 10 && /^[2-9]\d{9}$/.test(remaining)) {
                return { valid: true, message: 'Valid US/Canada number' };
            }
        }

        if (cleaned.length >= 10 && cleaned.length <= 15) {
            return { valid: true, message: 'Valid phone number format' };
        }

        return { valid: false, message: 'Invalid phone number format. Please check the number.' };
    };

    const handlePhoneNumberChange = (e) => {
        const value = e.target.value;
        setPhoneNumber(value);
        
        if (value.trim()) {
            const validation = validatePhoneNumber(value);
            if (!validation.valid) {
                setPhoneError(validation.message);
            } else {
                setPhoneError('');
            }
        } else {
            setPhoneError('');
        }
    };

    const formatPhoneNumber = (number) => {
        const cleaned = number.replace(/\D/g, '');
        if (!cleaned) return number;
        
        if (cleaned.startsWith('91') && cleaned.length === 12) {
            const countryCode = cleaned.substring(0, 2);
            const firstPart = cleaned.substring(2, 7);
            const secondPart = cleaned.substring(7);
            return `+${countryCode} ${firstPart} ${secondPart}`;
        }
        
        if (cleaned.startsWith('1') && cleaned.length === 11) {
            const countryCode = cleaned.substring(0, 1);
            const areaCode = cleaned.substring(1, 4);
            const firstPart = cleaned.substring(4, 7);
            const secondPart = cleaned.substring(7);
            return `+${countryCode} (${areaCode}) ${firstPart}-${secondPart}`;
        }
        
        if (cleaned.startsWith('971') && cleaned.length === 12) {
            const countryCode = cleaned.substring(0, 3);
            const firstPart = cleaned.substring(3, 5);
            const secondPart = cleaned.substring(5, 8);
            const thirdPart = cleaned.substring(8);
            return `+${countryCode} ${firstPart} ${secondPart} ${thirdPart}`;
        }
        
        return `+${cleaned}`;
    };

    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setAttachmentFile(file);

        try {
            const reader = new FileReader();
            reader.onload = async (event) => {
                const base64Data = event.target.result.split(',')[1];
                
                const res = await fetch(`${API}/api/upload-attachment`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        filename: file.name,
                        dataBase64: base64Data,
                        mimeType: file.type
                    })
                });

                const result = await res.json();
                if (result.success) {
                    setUploadedAttachment(result.attachmentName);
                    alert(`✅ File uploaded successfully: ${result.attachmentName}`);
                } else {
                    alert('❌ File upload failed: ' + result.error);
                }
            };
            reader.readAsDataURL(file);
        } catch (error) {
            alert('Error uploading file: ' + error.message);
        }
    };

    const addImageUrl = () => {
        if (imageUrl.trim()) {
            setImageUrls([...imageUrls, imageUrl.trim()]);
            setImageUrl('');
        }
    };

    const removeImageUrl = (index) => {
        setImageUrls(imageUrls.filter((_, i) => i !== index));
    };

    // --- STOP Stream API Call ---
    const handleStopStream = async () => {
        if (!selectedDevice) return;
        
        try {
            const res = await fetch(`${API}/api/stop-stream`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': API_KEY
                },
                body: JSON.stringify({ deviceId: selectedDevice })
            });
            const result = await res.json();
            
            if (result.success) {
                alert('🛑 Stop signal sent successfully. The process will halt momentarily.');
                setIsSending(false);
                setIsPaused(false);
            } else {
                alert('❌ Failed to send stop signal: ' + result.error);
            }
        } catch (error) {
            alert('Error communicating with server: ' + error.message);
        }
    };

    // --- NEW: PAUSE Stream API Call ---
    const handlePauseStream = async () => {
        if (!selectedDevice) return;
        
        try {
            const res = await fetch(`${API}/api/pause-stream`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': API_KEY
                },
                body: JSON.stringify({ deviceId: selectedDevice })
            });
            const result = await res.json();
            
            if (result.success) {
                setIsPaused(true);
                alert('⏸️ Stream paused successfully. Click Resume to continue.');
            } else {
                alert('❌ Failed to pause stream: ' + result.error);
            }
        } catch (error) {
            alert('Error communicating with server: ' + error.message);
        }
    };

    // --- NEW: RESUME Stream API Call ---
    const handleResumeStream = async () => {
        if (!selectedDevice) return;
        
        try {
            const res = await fetch(`${API}/api/resume-stream`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': API_KEY
                },
                body: JSON.stringify({ deviceId: selectedDevice })
            });
            const result = await res.json();
            
            if (result.success) {
                setIsPaused(false);
                alert('▶️ Stream resumed successfully.');
            } else {
                alert('❌ Failed to resume stream: ' + result.error);
            }
        } catch (error) {
            alert('Error communicating with server: ' + error.message);
        }
    };

    // Send single message
    const sendSingleMessage = async () => {
        if (!selectedDevice) {
            alert('⚠️ Please select a device');
            return;
        }
        
        const trimmedNumber = phoneNumber.trim();
        if (!trimmedNumber) {
            alert('⚠️ Please enter a phone number');
            setPhoneError('Phone number is required');
            return;
        }
        
        const validation = validatePhoneNumber(trimmedNumber);
        if (!validation.valid) {
            setPhoneError(validation.message);
            alert(`⚠️ ${validation.message}`);
            return;
        }
        
        if (!message && !imageUrls.length && !uploadedAttachment) {
            alert('⚠️ Please enter a message or add attachments');
            return;
        }

        setIsSending(true);
        setSendResult(null);

        try {
            const payload = {
                deviceId: selectedDevice,
                number: trimmedNumber,
                message: message || ''
            };

            if (imageUrls.length > 0) {
                payload.imageUrls = imageUrls;
            }

            if (uploadedAttachment) {
                payload.attachmentName = uploadedAttachment;
            }

            const res = await fetch(`${API}/api/send`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': API_KEY
                },
                body: JSON.stringify(payload)
            });

            const result = await res.json();
            setSendResult(result);
            
            if (result.success) {
                alert('✅ Message sent successfully!');
                setMessage('');
                setPhoneNumber('');
                setPhoneError('');
                setImageUrls([]);
                setUploadedAttachment(null);
                setAttachmentFile(null);
            } else {
                alert('❌ Failed to send: ' + result.error);
            }
        } catch (error) {
            alert('Error sending message: ' + error.message);
        } finally {
            setIsSending(false);
        }
    };

    // Send bulk messages
    const sendBulkMessages = async () => {
        if (!selectedDevice) {
            alert('⚠️ Please select a device');
            return;
        }
        if (!bulkNumbers) {
            alert('⚠️ Please enter phone numbers');
            return;
        }
        if (!message && !imageUrls.length && !uploadedAttachment) {
            alert('⚠️ Please enter a message or add attachments');
            return;
        }

        setIsSending(true);
        setSendResult(null);

        try {
            const payload = {
                deviceId: selectedDevice,
                numbers: bulkNumbers,
                message: message || ''
            };

            if (imageUrls.length > 0) {
                payload.imageUrls = imageUrls;
            }

            if (uploadedAttachment) {
                payload.attachmentName = uploadedAttachment;
            }

            const res = await fetch(`${API}/api/send-bulk`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': API_KEY
                },
                body: JSON.stringify(payload)
            });

            const result = await res.json();
            setSendResult(result);
            
            if (result.success) {
                alert(`✅ Bulk send completed! Sent: ${result.sent}, Failed: ${result.failed}`);
            } else {
                alert('❌ Failed to send: ' + result.error);
            }
        } catch (error) {
            alert('Error sending bulk messages: ' + error.message);
        } finally {
            setIsSending(false);
        }
    };

    // Send streaming bulk messages
    const sendStreamBulkMessages = async () => {
        if (!selectedDevice) {
            alert('⚠️ Please select a device');
            return;
        }
        if (!bulkNumbers) {
            alert('⚠️ Please enter phone numbers');
            return;
        }
        if (!message && !imageUrls.length && !uploadedAttachment) {
            alert('⚠️ Please enter a message or add attachments');
            return;
        }

        setIsSending(true);
        setIsPaused(false); // Reset pause state
        setStreamResults([]);
        setSendResult(null);

        try {
            const payload = {
                deviceId: selectedDevice,
                numbers: bulkNumbers,
                message: message || ''
            };

            if (imageUrls.length > 0) {
                payload.imageUrls = imageUrls;
            }

            if (uploadedAttachment) {
                payload.attachmentName = uploadedAttachment;
            }

            const res = await fetch(`${API}/api/send-bulk-stream`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': API_KEY
                },
                body: JSON.stringify(payload)
            });

            const reader = res.body.getReader();
            const decoder = new TextDecoder();
            let buffer = '';

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;

                buffer += decoder.decode(value, { stream: true });
                const lines = buffer.split('\n');
                
                for (let i = 0; i < lines.length - 1; i++) {
                    if (lines[i].trim()) {
                        try {
                            const data = JSON.parse(lines[i]);
                            setStreamResults(prev => [...prev, data]);
                        } catch (e) {
                            console.error('Parse error:', e);
                        }
                    }
                }
                buffer = lines[lines.length - 1];
            }

            setIsSending(false);
            setIsPaused(false);
            
            const successCount = streamResults.filter(r => r.status === 'success').length;
            const failCount = streamResults.filter(r => r.status === 'failed').length;
            alert(`✅ Streaming complete! Success: ${successCount}, Failed: ${failCount}`);
            
        } catch (error) {
            alert('Error sending streaming messages: ' + error.message);
            setIsSending(false);
            setIsPaused(false);
        }
    };

    const handleSend = () => {
        if (sendType === 'single') {
            sendSingleMessage();
        } else if (sendType === 'bulk') {
            sendBulkMessages();
        } else if (sendType === 'stream') {
            sendStreamBulkMessages();
        }
    };

    const getDeviceStatusColor = (status) => {
        if (status === 'CONNECTED') return '#4CAF50';
        if (status === 'WAITING_FOR_QR') return '#1A73E8';
        return '#ef4444';
    };

    return (
        <div className="wa-page">
            <style>{`
                .wa-page {
                    min-height: 100%;
                    background: #F8F9FA;
                }

                .main-container {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 24px 24px 48px;
                }

                .page-hero {
                    background: #FFFFFF;
                    border: 1px solid #E5E7EB;
                    border-radius: 16px;
                    padding: 22px 26px;
                    margin-bottom: 24px;
                    box-shadow: 0 2px 12px rgba(30, 58, 95, 0.05);
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    align-items: center;
                    gap: 16px;
                }

                .page-title {
                    font-size: 1.6rem;
                    font-weight: 700;
                    color: #333333;
                    margin-bottom: 4px;
                    display: flex;
                    align-items: center;
                }

                .page-subtitle {
                    color: #7A869A;
                    font-size: 0.9rem;
                    font-weight: 400;
                    margin: 0;
                }

                .device-count-badge {
                    background: #EAF4FE !important;
                    color: #1A73E8 !important;
                    border: 1px solid #c5ddf5;
                    font-weight: 600;
                    font-size: 0.85rem;
                    padding: 10px 18px !important;
                }

                .compose-grid {
                    display: grid;
                    grid-template-columns: 1fr 340px;
                    gap: 24px;
                    align-items: start;
                }

                .compose-primary {
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                    min-width: 0;
                }

                .compose-sidebar {
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                    position: sticky;
                    top: 80px;
                }

                .card-modern {
                    background: #FFFFFF;
                    border-radius: 16px;
                    border: 1px solid #E5E7EB;
                    box-shadow: 0 2px 10px rgba(30, 58, 95, 0.04);
                    transition: box-shadow 0.25s ease;
                    overflow: hidden;
                }

                .card-modern:hover {
                    box-shadow: 0 6px 20px rgba(30, 58, 95, 0.08);
                }

                .card-header-custom {
                    padding: 16px 22px;
                    background: #F0F5FA;
                    border-bottom: 1px solid #E5E7EB;
                    border-left: 4px solid #1A73E8;
                }

                .card-header-custom h6 {
                    color: #333333 !important;
                    font-size: 0.9rem;
                    display: flex;
                    align-items: center;
                }

                .card-body-custom {
                    padding: 22px;
                    background: #FFFFFF;
                }

                .card-body-custom--compact {
                    padding: 20px 22px;
                }

                .form-label-custom {
                    font-weight: 600;
                    font-size: 0.8rem;
                    color: #333333;
                    letter-spacing: 0.4px;
                    text-transform: uppercase;
                    margin-bottom: 8px;
                    display: block;
                }

                .form-control-custom {
                    border: 1.5px solid #E5E7EB;
                    border-radius: 12px;
                    padding: 12px 16px;
                    font-size: 14px;
                    transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
                    background: #F8F9FA;
                    width: 100%;
                    color: #333333;
                }

                .form-control-custom:focus {
                    border-color: #1A73E8;
                    box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.12);
                    background: #FFFFFF;
                    outline: none;
                }

                .form-control-custom::placeholder {
                    color: #7A869A;
                }

                .form-control-custom.error {
                    border-color: #ef4444;
                    background: #FCE8E6;
                }

                .form-control-custom.error:focus {
                    border-color: #ef4444;
                    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.12);
                }

                .form-control-custom.success {
                    border-color: #4CAF50;
                    background: #EAF4FE;
                }

                .form-control-custom.success:focus {
                    border-color: #4CAF50;
                    box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.12);
                }

                .phone-validation-error {
                    color: #ef4444;
                    font-size: 0.8rem;
                    margin-top: 6px;
                    display: flex;
                    align-items: center;
                    gap: 4px;
                }

                .phone-validation-success {
                    color: #4CAF50;
                    font-size: 0.8rem;
                    margin-top: 6px;
                    display: flex;
                    align-items: center;
                    gap: 4px;
                }

                .phone-formatted {
                    background: #F0F5FA;
                    padding: 6px 12px;
                    border-radius: 8px;
                    font-size: 0.85rem;
                    color: #333333;
                    margin-top: 6px;
                    display: inline-block;
                    font-family: monospace;
                }

                .device-select {
                    border: 1.5px solid #E5E7EB;
                    border-radius: 12px;
                    padding: 12px 16px;
                    font-size: 14px;
                    background: #F8F9FA;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    width: 100%;
                    color: #333333;
                }

                .device-select:focus {
                    border-color: #1A73E8;
                    box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.12);
                    background: #FFFFFF;
                    outline: none;
                }

                .mode-tabs {
                    display: inline-flex;
                    background: #F0F5FA;
                    border: 1px solid #E5E7EB;
                    border-radius: 50px;
                    padding: 4px;
                    gap: 4px;
                    flex-wrap: wrap;
                }

                .mode-tab {
                    border: none !important;
                    background: transparent !important;
                    color: #7A869A !important;
                    font-weight: 600;
                    font-size: 0.82rem;
                    padding: 8px 18px !important;
                    border-radius: 50px !important;
                    transition: all 0.2s ease;
                }

                .mode-tab:hover:not(.active) {
                    color: #333333 !important;
                    background: rgba(255, 255, 255, 0.6) !important;
                }

                .mode-tab.active {
                    background: #1A73E8 !important;
                    color: #FFFFFF !important;
                    box-shadow: 0 2px 8px rgba(26, 115, 232, 0.3);
                }

                .mode-hint {
                    display: block;
                    margin-top: 10px;
                    font-size: 0.8rem;
                    color: #7A869A;
                }

                .char-badge {
                    background: #F0F5FA !important;
                    color: #7A869A !important;
                    border: 1px solid #E5E7EB;
                    font-weight: 500;
                    font-size: 0.75rem;
                    padding: 6px 12px;
                }

                .btn-primary-custom {
                    background: #1A73E8;
                    border: none;
                    border-radius: 12px;
                    padding: 12px 22px;
                    font-weight: 600;
                    font-size: 14px;
                    color: #FFFFFF;
                    white-space: nowrap;
                    transition: all 0.2s ease;
                }

                .btn-primary-custom:hover {
                    background: #1558b0;
                    box-shadow: 0 4px 12px rgba(26, 115, 232, 0.3);
                }

                .send-panel {
                    background: linear-gradient(180deg, #FFFFFF 0%, #F8FBFF 100%);
                    border: 1px solid #c5ddf5;
                }

                .send-panel-body {
                    padding: 24px 22px;
                }

                .send-panel-title {
                    font-size: 0.95rem;
                    font-weight: 700;
                    color: #333333;
                    margin-bottom: 6px;
                }

                .send-panel-desc {
                    font-size: 0.8rem;
                    color: #7A869A;
                    margin-bottom: 18px;
                }

                .btn-success-custom {
                    background: #3BA949;
                    border: none;
                    border-radius: 14px;
                    padding: 16px 24px;
                    font-weight: 700;
                    font-size: 1rem;
                    color: #FFFFFF;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    transition: all 0.2s ease;
                    width: 100%;
                }

                .btn-success-custom:hover:not(:disabled) {
                    background: #339940;
                    box-shadow: 0 8px 24px rgba(59, 169, 73, 0.35);
                    transform: translateY(-1px);
                }

                .btn-success-custom:disabled {
                    opacity: 0.55;
                    cursor: not-allowed;
                    transform: none;
                }

                /* --- Stop Button Styles --- */
                .btn-danger-custom {
                    background: #ef4444;
                    border: none;
                    border-radius: 14px;
                    padding: 16px 24px;
                    font-weight: 700;
                    font-size: 1rem;
                    color: #FFFFFF;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    transition: all 0.2s ease;
                    width: 100%;
                    margin-top: 12px;
                }

                .btn-danger-custom:hover {
                    background: #dc2626;
                    box-shadow: 0 8px 24px rgba(239, 68, 68, 0.35);
                    transform: translateY(-1px);
                }

                /* --- Pause Button Styles --- */
                .btn-warning-custom {
                    background: #f59e0b;
                    border: none;
                    border-radius: 14px;
                    padding: 16px 24px;
                    font-weight: 700;
                    font-size: 1rem;
                    color: #FFFFFF;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    transition: all 0.2s ease;
                    width: 100%;
                    margin-top: 12px;
                }

                .btn-warning-custom:hover {
                    background: #d97706;
                    box-shadow: 0 8px 24px rgba(245, 158, 11, 0.35);
                    transform: translateY(-1px);
                }

                /* --- Resume Button Styles --- */
                .btn-info-custom {
                    background: #0ea5e9;
                    border: none;
                    border-radius: 14px;
                    padding: 16px 24px;
                    font-weight: 700;
                    font-size: 1rem;
                    color: #FFFFFF;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    transition: all 0.2s ease;
                    width: 100%;
                    margin-top: 12px;
                }

                .btn-info-custom:hover {
                    background: #0284c7;
                    box-shadow: 0 8px 24px rgba(14, 165, 233, 0.35);
                    transform: translateY(-1px);
                }

                .tag-image {
                    background: #EAF4FE;
                    border: 1px solid #c5ddf5;
                    border-radius: 20px;
                    padding: 6px 12px;
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    font-size: 12px;
                    color: #1A73E8;
                    margin: 4px 4px 0 0;
                }

                .tag-image .remove-btn {
                    background: none;
                    border: none;
                    color: #ef4444;
                    cursor: pointer;
                    font-size: 16px;
                    padding: 0 4px;
                    line-height: 1;
                }

                .tag-image .remove-btn:hover {
                    color: #dc2626;
                }

                .upload-area {
                    border: 2px dashed #d1d9e0;
                    border-radius: 14px;
                    padding: 28px 20px;
                    text-align: center;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    background: #F8F9FA;
                }

                .upload-area:hover {
                    border-color: #1A73E8;
                    background: #EAF4FE;
                }

                .upload-icon {
                    font-size: 2.2rem;
                    color: #1A73E8;
                    display: block;
                    margin-bottom: 8px;
                }

                .uploaded-file {
                    background: #EAF4FE;
                    border: 1px solid #c5ddf5;
                    border-radius: 12px;
                    padding: 12px 14px;
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    margin-top: 12px;
                    flex-wrap: wrap;
                }

                .stream-item {
                    padding: 10px 14px;
                    border-radius: 10px;
                    margin-bottom: 6px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 13px;
                    flex-wrap: wrap;
                    gap: 8px;
                }

                .stream-success {
                    background: #EAF4FE;
                    border-left: 3px solid #4CAF50;
                    color: #333333;
                }

                .stream-failed {
                    background: #FCE8E6;
                    border-left: 3px solid #ef4444;
                    color: #991b1b;
                }

                .stream-pending {
                    background: #FFF3CD;
                    border-left: 3px solid #f59e0b;
                    color: #92400e;
                }

                .stream-paused {
                    background: #E0F2FE;
                    border-left: 3px solid #0ea5e9;
                    color: #0369a1;
                }

                .stream-scroll {
                    max-height: 360px;
                    overflow-y: auto;
                }

                .summary-box {
                    padding: 16px 18px;
                    border-radius: 12px;
                }

                .summary-success {
                    background: #EAF4FE;
                    border: 1px solid #c5ddf5;
                }

                .summary-error {
                    background: #FCE8E6;
                    border: 1px solid #f5c6c2;
                }

                .ui-icon {
                    color: #1A73E8;
                    margin-right: 6px;
                }

                .ui-icon-success { color: #4CAF50; }
                .ui-icon-danger { color: #ef4444; }
                .ui-icon-warning { color: #f59e0b; }
                .ui-icon-pause { color: #0ea5e9; }

                .no-device-alert {
                    background: #FFF3CD;
                    border: 1px solid #ffe69c;
                    border-radius: 10px;
                    padding: 10px 12px;
                    margin-top: 10px;
                    font-size: 0.82rem;
                    color: #856404;
                }

                .phone-input-wrapper {
                    position: relative;
                }

                .pause-badge {
                    background: #0ea5e9 !important;
                    color: #FFFFFF !important;
                    border: none;
                    font-weight: 600;
                    font-size: 0.75rem;
                    padding: 4px 12px;
                    margin-left: 8px;
                }

                @media (max-width: 991px) {
                    .compose-grid {
                        grid-template-columns: 1fr;
                    }

                    .compose-sidebar {
                        position: static;
                    }
                }

                @media (max-width: 768px) {
                    .main-container {
                        padding: 16px 16px 32px;
                    }

                    .page-hero {
                        padding: 18px;
                    }

                    .page-title {
                        font-size: 1.3rem;
                    }

                    .card-body-custom {
                        padding: 16px;
                    }

                    .card-header-custom {
                        padding: 14px 16px;
                    }

                    .mode-tabs {
                        width: 100%;
                        justify-content: center;
                    }

                    .mode-tab {
                        flex: 1;
                        padding: 8px 10px !important;
                    }
                }

                @media (max-width: 576px) {
                    .page-title { font-size: 1.15rem; }
                    .btn-success-custom { font-size: 0.9rem; padding: 14px 18px; }
                }
            `}</style>

            <Header title="Send Message" />

            <div className="main-container">
                <div className="page-hero">
                    <div>
                        <h1 className="page-title"><i className="bi bi-send-fill ui-icon" aria-hidden="true" /> Send Message</h1>
                        <p className="page-subtitle">Send messages, images, and files to your contacts</p>
                    </div>
                    <span className="badge device-count-badge rounded-pill">
                        <i className="bi bi-phone me-1" aria-hidden="true" /> {devices.length} Device{devices.length !== 1 ? 's' : ''} Connected
                    </span>
                </div>

                <div className="compose-grid">
                    <div className="compose-primary">

                {/* Device Selection Card */}
                <div className="card-modern">
                    <div className="card-body-custom card-body-custom--compact">
                        <div className="row g-4">
                            <div className="col-md-6">
                                <label className="form-label-custom">Select Device</label>
                                <select 
                                    className="device-select w-100"
                                    value={selectedDevice}
                                    onChange={(e) => setSelectedDevice(e.target.value)}
                                >
                                    <option value="">Choose a device...</option>
                                    {devices.map(device => (
                                        <option key={device.id} value={device.id}>
                                            +{device.id} 
                                            {device.status === 'CONNECTED' ? ' · Connected' : ''}
                                        </option>
                                    ))}
                                </select>
                                {devices.length === 0 && (
                                    <div className="no-device-alert">
                                        <i className="bi bi-exclamation-triangle-fill ui-icon-warning me-1" aria-hidden="true" /> No connected devices found. Please link a device first.
                                    </div>
                                )}
                            </div>
                            <div className="col-md-6">
                                <label className="form-label-custom">Send Mode</label>
                                <div className="mode-tabs">
                                    <button 
                                        type="button"
                                        className={`btn mode-tab ${sendType === 'single' ? 'active' : ''}`}
                                        onClick={() => setSendType('single')}
                                    >
                                        Single
                                    </button>
                                    <button 
                                        type="button"
                                        className={`btn mode-tab ${sendType === 'bulk' ? 'active' : ''}`}
                                        onClick={() => setSendType('bulk')}
                                    >
                                        Bulk
                                    </button>
                                    <button 
                                        type="button"
                                        className={`btn mode-tab ${sendType === 'stream' ? 'active' : ''}`}
                                        onClick={() => setSendType('stream')}
                                    >
                                        Stream                                    </button>
                                </div>
                                <small className="mode-hint">
                                    {sendType === 'single' ? 'Send to one recipient' :
                                     sendType === 'bulk' ? 'Send to multiple recipients with summary' :
                                     'Real-time progress for bulk messages'}
                                </small>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Recipients Card */}
                <div className="card-modern">
                    <div className="card-header-custom">
                        <h6 className="fw-bold m-0">
                            {sendType === 'single' ? (
                                <><i className="bi bi-phone ui-icon" aria-hidden="true" /> Recipient</>
                            ) : (
                                <><i className="bi bi-people ui-icon" aria-hidden="true" /> Recipients</>
                            )}
                        </h6>
                    </div>
                    <div className="card-body-custom">
                        {sendType === 'single' ? (
                            <div>
                                <label className="form-label-custom">Phone Number</label>
                                <div className="phone-input-wrapper">
                                    <input 
                                        type="text" 
                                        className={`form-control-custom w-100 ${
                                            phoneNumber.trim() && phoneError ? 'error' : 
                                            phoneNumber.trim() && !phoneError ? 'success' : ''
                                        }`}
                                        placeholder="e.g., 9876543210"
                                        value={phoneNumber}
                                        onChange={handlePhoneNumberChange}
                                        onBlur={() => {
                                            if (phoneNumber.trim()) {
                                                const validation = validatePhoneNumber(phoneNumber);
                                                if (!validation.valid) {
                                                    setPhoneError(validation.message);
                                                } else {
                                                    setPhoneError('');
                                                }
                                            }
                                        }}
                                    />
                                    {phoneNumber.trim() && phoneError && (
                                        <div className="phone-validation-error">
                                            <i className="bi bi-exclamation-circle-fill" />
                                            {phoneError}
                                        </div>
                                    )}
                                    {phoneNumber.trim() && !phoneError && (
                                        <div className="phone-validation-success">
                                            <i className="bi bi-check-circle-fill" />
                                            Valid phone number
                                        </div>
                                    )}
                                    {phoneNumber.trim() && !phoneError && (
                                        <div className="phone-formatted">
                                            <i className="bi bi-phone me-1" />
                                            {formatPhoneNumber(phoneNumber)}
                                        </div>
                                    )}
                                </div>
                                <small className="text-muted">Enter phone number without + or spaces. Supports international numbers.</small>
                            </div>
                        ) : (
                            <div>
                                <label className="form-label-custom">Phone Numbers</label>
                                <textarea 
                                    className="form-control-custom w-100"
                                    rows="4"
                                    placeholder="9876543210, 9876543211, 9876543212"
                                    value={bulkNumbers}
                                    onChange={(e) => setBulkNumbers(e.target.value)}
                                    style={{ resize: 'vertical' }}
                                />
                                <small className="text-muted">Separate multiple numbers with commas or new lines</small>
                            </div>
                        )}
                    </div>
                </div>

                {/* Message Card */}
                <div className="card-modern">
                    <div className="card-header-custom">
                        <h6 className="fw-bold m-0"><i className="bi bi-pencil-square ui-icon" aria-hidden="true" /> Message</h6>
                    </div>
                    <div className="card-body-custom">
                        <textarea 
                            className="form-control-custom w-100"
                            rows="4"
                            placeholder="Type your message here..."
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            style={{ resize: 'vertical' }}
                        />
                        <div className="mt-3">
                            <span className="badge char-badge rounded-pill">
                                {message.length} characters
                            </span>
                        </div>
                    </div>
                </div>

                {/* Attachments Card */}
                <div className="card-modern">
                    <div className="card-header-custom">
                        <h6 className="fw-bold m-0"><i className="bi bi-paperclip ui-icon" aria-hidden="true" /> Attachments</h6>
                    </div>
                    <div className="card-body-custom">
                        <div className="row g-4">
                            <div className="col-md-6">
                                <label className="form-label-custom">Upload File</label>
                                <div className="upload-area" onClick={() => document.getElementById('fileInput').click()}>
                                    <input 
                                        type="file" 
                                        id="fileInput"
                                        className="d-none"
                                        onChange={handleFileUpload}
                                    />
                                    <div>
                                        <i className="bi bi-folder2 upload-icon" aria-hidden="true" />
                                        <div className="fw-bold mt-1">Click to upload</div>
                                        <div className="text-muted small">Images, Documents, Audio, Video</div>
                                    </div>
                                </div>
                                {uploadedAttachment && (
                                    <div className="uploaded-file">
                                        <i className="bi bi-file-earmark-text ui-icon" style={{ fontSize: '1.25rem' }} aria-hidden="true" />
                                        <div className="flex-grow-1">
                                            <div className="fw-bold small">{uploadedAttachment}</div>
                                            <div className="text-muted small">Uploaded successfully</div>
                                        </div>
                                        <button 
                                            className="btn btn-sm btn-outline-danger rounded-pill"
                                            onClick={() => { setUploadedAttachment(null); setAttachmentFile(null); }}
                                        >
                                            Remove
                                        </button>
                                    </div>
                                )}
                            </div>
                            <div className="col-md-6">
                                <label className="form-label-custom">Image URLs</label>
                                <div className="d-flex gap-2">
                                    <input 
                                        type="text" 
                                        className="form-control-custom flex-grow-1"
                                        placeholder="https://example.com/image.jpg"
                                        value={imageUrl}
                                        onChange={(e) => setImageUrl(e.target.value)}
                                        onKeyPress={(e) => e.key === 'Enter' && addImageUrl()}
                                    />
                                    <button className="btn-primary-custom" onClick={addImageUrl}>
                                        Add
                                    </button>
                                </div>
                                <div className="mt-2">
                                    {imageUrls.length === 0 ? (
                                        <div className="text-muted small">No images added yet</div>
                                    ) : (
                                        imageUrls.map((url, index) => (
                                            <span key={index} className="tag-image">
                                                <i className="bi bi-image ui-icon me-1" aria-hidden="true" /> {url.substring(0, 30)}...
                                                <button 
                                                    className="remove-btn"
                                                    onClick={() => removeImageUrl(index)}
                                                >
                                                    ×
                                                </button>
                                            </span>
                                        ))
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                    </div>

                    <div className="compose-sidebar">

                {/* Send Button */}
                <div className="card-modern send-panel">
                    <div className="send-panel-body">
                        <div className="send-panel-title">Ready to send?</div>
                        <p className="send-panel-desc">Review your message and click below to deliver.</p>
                        
                        <button 
                            className="btn-success-custom"
                            onClick={handleSend}
                            disabled={isSending || !selectedDevice || (sendType === 'single' && !!phoneError)}
                        >
                            {isSending ? (
                                <>
                                    <span className="spinner-border spinner-border-sm"></span>
                                    {isPaused ? 'Paused...' : 'Sending...'}
                                </>
                            ) : (
                                <>
                                    {sendType === 'single' ? (
                                        <><i className="bi bi-send-fill" aria-hidden="true" /> Send Message</>
                                    ) : sendType === 'bulk' ? (
                                        <><i className="bi bi-broadcast" aria-hidden="true" /> Send Bulk Messages</>
                                    ) : (
                                        <><i className="bi bi-activity" aria-hidden="true" /> Stream Messages</>
                                    )}
                                </>
                            )}
                        </button>

                        {/* Stream Control Buttons - Only visible during Stream sending */}
                        {isSending && sendType === 'stream' && (
                            <>
                                {/* PAUSE Button - Show when NOT paused */}
                                {!isPaused && (
                                    <button 
                                        className="btn-warning-custom"
                                        onClick={handlePauseStream}
                                    >
                                        <i className="bi bi-pause-circle-fill" aria-hidden="true" /> Pause Stream
                                    </button>
                                )}

                                {/* RESUME Button - Show when PAUSED */}
                                {isPaused && (
                                    <button 
                                        className="btn-info-custom"
                                        onClick={handleResumeStream}
                                    >
                                        <i className="bi bi-play-circle-fill" aria-hidden="true" /> Resume Stream
                                    </button>
                                )}

                                {/* STOP Button - Always visible during stream */}
                                <button 
                                    className="btn-danger-custom"
                                    onClick={handleStopStream}
                                >
                                    <i className="bi bi-stop-circle-fill" aria-hidden="true" /> Stop Stream
                                </button>
                            </>
                        )}
                    </div>
                </div>

                {/* Streaming Results */}
                {sendType === 'stream' && streamResults.length > 0 && (
                    <div className="card-modern">
                        <div className="card-header-custom">
                            <h6 className="fw-bold m-0">
                                <i className="bi bi-bar-chart-fill ui-icon" aria-hidden="true" /> Live Progress 
                                <span className="badge pause-badge rounded-pill">
                                    {streamResults.filter(r => r.status === 'success').length} sent
                                </span>
                                {isPaused && (
                                    <span className="badge pause-badge rounded-pill" style={{ background: '#0ea5e9 !important' }}>
                                        <i className="bi bi-pause-fill me-1" /> Paused
                                    </span>
                                )}
                            </h6>
                        </div>
                        <div className="card-body-custom stream-scroll">
                            {streamResults.map((result, index) => (
                                <div key={index} className={`stream-item ${result.status === 'success' ? 'stream-success' : result.status === 'failed' ? 'stream-failed' : 'stream-pending'}`}>
                                    <span>
                                        <span className="fw-bold">#{result.index}</span>
                                        <span className="ms-2">{result.number}</span>
                                    </span>
                                    <span>
                                        {result.status === 'success' && <><i className="bi bi-check-circle-fill ui-icon-success me-1" aria-hidden="true" /> Sent</>}
                                        {result.status === 'failed' && <><i className="bi bi-x-circle-fill ui-icon-danger me-1" aria-hidden="true" /> {result.error || 'Failed'}</>}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Result Summary */}
                {sendResult && sendType !== 'stream' && (
                    <div className="card-modern">
                        <div className="card-body-custom">
                            <div className={`summary-box ${sendResult.success ? 'summary-success' : 'summary-error'}`}>
                                <div className="d-flex justify-content-between align-items-start">
                                    <div>
                                        <h6 className="fw-bold mb-1">
                                            {sendResult.success ? (
                                                <><i className="bi bi-check-circle-fill ui-icon-success me-1" aria-hidden="true" /> Success</>
                                            ) : (
                                                <><i className="bi bi-x-circle-fill ui-icon-danger me-1" aria-hidden="true" /> Failed</>
                                            )}
                                        </h6>
                                        {sendResult.total && (
                                            <div className="small">
                                                Total: {sendResult.total} | 
                                                Sent: {sendResult.sent || 0} | 
                                                Failed: {sendResult.failed || 0}
                                            </div>
                                        )}
                                        {sendResult.results && (
                                            <div className="mt-2" style={{ maxHeight: '150px', overflowY: 'auto' }}>
                                                {sendResult.results.map((r, i) => (
                                                    <div key={i} className="small d-flex justify-content-between">
                                                        <span>{r.number}</span>
                                                        <span>{r.success ? <i className="bi bi-check-circle-fill ui-icon-success" aria-hidden="true" /> : <i className="bi bi-x-circle-fill ui-icon-danger" aria-hidden="true" />}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                        {sendResult.error && (
                                            <div className="mt-2 small text-danger">
                                                Error: {sendResult.error}
                                                {sendResult.details && <div className="text-muted">{sendResult.details}</div>}
                                            </div>
                                        )}
                                    </div>
                                    <button 
                                        className="btn btn-sm btn-outline-secondary rounded-pill"
                                        onClick={() => setSendResult(null)}
                                    >
                                        Dismiss
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                    </div>
                </div>
            </div>
        </div>
    );
};

export default SendMessage;